import api from '@/api';

const resource = 'merenda/grupo-alimento-merenda';

export default {
  criarGrupoAlimentoMerenda( data ) {
    return api.post( `${resource}`, data );
  },

  editarGrupoAlimentoMerenda( data ) {
    return api.put( `${resource}/${data.identificadortipomovimento}`, data);
  },

  deletarGrupoAlimentoMerenda( id ) {
    return api.delete(`${resource}/${id}`);
  },

  buscarGruposAlimentoMerenda(data) {
    return api.get( `${resource}`,  {
      params: data
    }  );
  }
};
